import { Component, Input, OnInit } from '@angular/core';
import { map, Observable, startWith } from 'rxjs';
import { FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'app-password-strength',
    templateUrl: './password-strength.component.html',
    styleUrl: './password-strength.component.scss'
})
export class PasswordStrengthComponent implements OnInit {
    @Input() inputFormControlName: string | undefined;

    checkPassword$: Observable<{ isVisible: boolean; strength: number }> | undefined = new Observable<{
        isVisible: boolean;
        strength: number;
    }>();

    constructor(private rootFormGroup: FormGroupDirective) {}

    ngOnInit() {
        this.checkPassword$ = this.rootFormGroup.control.get(this.inputFormControlName!)?.valueChanges.pipe(
            map((value) => {
                const passwordStrength = this.checkPassword(value);
                this.setClasses(passwordStrength);

                return {
                    isVisible: value.length > 0,
                    strength: passwordStrength
                };
            }),
            startWith({
                isVisible: false,
                strength: 0
            })
        );
    }

    // Must contain at least one lowercase letter
    // Must contain at least one number
    // Must contain at least one special character
    private checkPassword(password: string): number {
        let count: number = 0;
        const numbers: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const specialChars: string[] = [',', '.', '/', ';', "'", '[', ']', "'", '=', '-', ')', '(', '*', '&'];

        password.split('').every((char) => {
            if (char === char.toLowerCase()) {
                count += 1;
                return false;
            }
            return true;
        });

        password.split('').every((char) => {
            if (char === char.toUpperCase()) {
                count += 1;
                return false;
            }
            return true;
        });

        numbers.every((number) => {
            if (password.includes(number)) {
                count += 1;
                return false;
            }
            return true;
        });

        specialChars.every((char) => {
            if (password.includes(char)) {
                count += 1;
                return false;
            }
            return true;
        });

        return count;
    }

    private setClasses(passwordStrength: number) {
        const points: NodeListOf<HTMLElement> = document.querySelectorAll('.point');

        points.forEach((point, index) => {
            if (passwordStrength > 2) {
                this.setBackground('rgb(103, 201, 77)', passwordStrength, index, point);
            } else if (passwordStrength > 1) {
                this.setBackground('rgb(239, 142, 52)', passwordStrength, index, point);
            } else {
                this.setBackground('rgb(188, 64, 58)', passwordStrength, index, point);
            }
        });
    }

    private setBackground(color: string, passwordStrength: number, index: number, point: HTMLElement) {
        if (index < passwordStrength) {
            point.style.backgroundColor = color;
        } else {
            point.style.backgroundColor = '#DDD';
        }
    }
}
